export const HM_BRAND = ['H&M', 'HM'] as ReadonlyArray<string>

// Crossbrands constants order should be same as Crossbrands priority order
export const CROSSBRANDS = [
  'BOPIS',
  'FULFILL_FROM_STORE',
  'ARKET',
  'COS',
  'MONKI',
  'STORIES',
  'WEEKDAY',
  'RESELL',
] as ReadonlyArray<string>

export const RESELL_BRAND = 'SELLPY' as const

export const BOPIS_TYPE = 'BOPIS' as const
export const DROPSHIP_TYPE = 'DROPSHIP' as const
export const RESELL_TYPE = 'RESELL' as const
